import { render, staticRenderFns } from "./forgotUsernameSupport.vue?vue&type=template&id=77d9fd56&"
import script from "./forgotUsernameSupport.vue?vue&type=script&lang=js&"
export * from "./forgotUsernameSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports